export default import.meta.ROLLDOWN_FILE_URL_yF$qpnhvM_lmu5QZvvbijw